import { Component, OnInit } from '@angular/core';
import { SocialMediaService } from '../../_services/social-media.service';
import { LocationService } from '../../_services/location.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  socialMedia: any;
  country: string;
  language: string;

  constructor(private socialMediaService: SocialMediaService, private locationService: LocationService) { }

  getSocialMedia(country: string, language: string): void {
    this.socialMediaService.getSocialMedia(country, language)
      .subscribe(
        resultArray => {
          this.socialMedia = resultArray;
        },
        error => console.log('Error ::' + error)
      );
  }

  ngOnInit() {
    setTimeout(() => {
      this.country = this.locationService.country;
      this.language = this.locationService.langCode;
      this.getSocialMedia(this.country, this.language);
    }, 1500);
  }

}
